export enum ImportSource {
  File = 'file',
  DriverCard = 'driverCard',
  TachographDiscs = 'tachographDiscs',
  ScanDiscs = 'scanDiscs',
  Gps = 'gps',
  Tms = 'tms',
  ActivityFile = 'activityFile',
  Delegations = 'delegations',
  Absences = 'absences',
  Drivers = 'drivers',
  BorderCrossings = 'borderCrossings',
  WebfleetBorders = 'webfleetBorders',
  ActivityService = 'activityService',
}
